import { VhcRecordLogService, VHCRecordPartInput } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type CreateWheelPartsInput = {
  logId: number;
  itemId: number;
  requestBody?: VHCRecordPartInput;
};

export const useSaveWheelPartsMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.postVhcRecordsItemsWheelTyresParts, CreateWheelPartsInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, requestBody }: CreateWheelPartsInput) =>
      VhcRecordLogService.postVhcRecordsItemsWheelTyresParts(logId, itemId, requestBody),
    options
  );
